import React, { useContext, useEffect, useMemo, useState } from 'react'
import { Bar, BarChart, CartesianGrid, Tooltip, XAxis, YAxis } from 'recharts'

// import {
//   CATEGORY_COLORS_ENUM,
import { useNavigate } from 'react-router-dom'

//   FILTER_ENUM,
import '../../assets/css/rhybus.css'
import '../../assets/css/variables.css'
import '../../assets/icons/style.css'
//   SURVEY_FORM_LIST,
import { mpfRListsHttp } from '../../assets/ts/api/mpf-r-lists-http'
import { or } from '../../assets/ts/data/data'
import { defaultToEmptyString } from '../../assets/ts/formatting/formatting'
//   SURVEY_REQUIRED_LIST,
import { CATEGORY_COLORS_ENUM } from '../../assets/ts/general/general'
// } from '../../Configuration'
import { ReturnErrorMessage, ShowErrorMessage } from '../../assets/ts/pii/pii'
import PageOverlayBusy from '../../components/page-overlay/page-overlay-busy'
import { MetadataContext } from '../../store/metadata-context-provider'
import { PreviousPageContext } from '../../store/previous-page-provider'
import { RoleContext } from '../../store/role-context-provider'
import {
  ALL_SELECT_OPTION_STRING,
  NONE_SELECT_OPTION_STRING,
} from '../../utils/constants/global-constants'
import NO_RESULTS from '../../utils/constants/no-results'
import CustomSelect from '../../utils/controls/custom-select'
import './surveyForm.css'

// eslint-disable-next-line import/exports-last
export const SURVEY_FORM_LIST = 'SurveyFormList'
// eslint-disable-next-line import/exports-last
export const SURVEY_REQUIRED_LIST = 'SurveyRequiredList'
const SurveyReport = () => {
  const {
    initialInquiryAndDueoutFilter,
    isAssignedComponentOwner,
    isCPOwner,
    isLeadership,
    isLoading,
    isMAJCOMOwner,
    isMPFOwner,
    isSectionOwner,
    isSiteAdmin
  } = useContext(RoleContext)

  const isOwners =
    isCPOwner ||
    isSiteAdmin ||
    isLeadership ||
    isMPFOwner ||
    isSectionOwner ||
    isAssignedComponentOwner ||
    isMAJCOMOwner
  const {
    assignedComponentCodeFilter,
    cssPASCODES,
    majcomCodeFilter,
    sectionCodeFilter,
    servicingOrganizationFilter,
    servicingOrganizationWithoutSectionFilter,
  } = initialInquiryAndDueoutFilter
  const { currentPage, setCurrentPage, setPreviousPage } =
  useContext(PreviousPageContext)
  const [showPageOverlay, setShowPageOverlay] = useState<boolean>(false)
  const { componentOptions, majcomOptions, sectionOptions } = useContext(MetadataContext)
  useEffect(() => {
    if (currentPage !== location.pathname) {
      setPreviousPage(currentPage)
      setCurrentPage(location.pathname) 
    } 
  }, [location, currentPage]) 
  const filterOrder = {
    AssignedComponent: 2,
    FY: 1,
    Section: 5,
    ServicingMAJCOM: 3,
    ServicingOrganization: 4,
  }
  function convertCodeToString(
    codes: number[],
    options: {
      label: string
      value: number
    }[]
  ): string[] {
    return options
      .filter(({ value }) => codes?.includes(value) && value !== -1)
      .map(({ label }) => label)
  }
  const assignedComponents: string[] = useMemo(() => {
    return convertCodeToString(assignedComponentCodeFilter, componentOptions)
  }, [assignedComponentCodeFilter, componentOptions])
  const majcom: string[] = useMemo(() => {
    return convertCodeToString(majcomCodeFilter, majcomOptions)
  }, [majcomCodeFilter, majcomOptions])
  const section: string[] = useMemo(() => {
    return convertCodeToString(sectionCodeFilter, sectionOptions)
  }, [sectionCodeFilter, sectionOptions])
  const navigate = useNavigate()
  if (!isLoading) {
    if (!isOwners) {
      navigate('/accessdenied')
    }
  }
  const usersRoles = useMemo(
    () => ({
      assignedComponentCodeFilter: assignedComponents,
      cssPASCODES: cssPASCODES,
      majcomCodeFilter: majcom,
      sectionCodeFilter: section,
      servicingOrganizationFilter,
      servicingOrganizationWithoutSectionFilter,
    }),
    [
      assignedComponents,
      cssPASCODES,
      majcom,
      section,
      servicingOrganizationFilter,
      servicingOrganizationWithoutSectionFilter,
    ]
  )

  const chartLayout = [
    {
      name: 'SatisfactionOnQualityOfYourService',
      value: {
        Dissatisfied: 0,
        Neutral: 0,
        Satisfied: 0,
        'Very Dissatisfied': 0,
        'Very Satisfied': 0,
      },
    },
    {
      name: 'SatisfactionOnResolutionTimeliness',
      value: {
        Dissatisfied: 0,
        Neutral: 0,
        Satisfied: 0,
        'Very Dissatisfied': 0,
        'Very Satisfied': 0,
      },
    },
    {
      name: 'OverallSatisfactionForTheResolution',
      value: {
        Dissatisfied: 0,
        Neutral: 0,
        Satisfied: 0,
        'Very Dissatisfied': 0,
        'Very Satisfied': 0,
      },
    },
    {
      name: 'MPFMadeItEasyForMe',
      value: {
        Dissatisfied: 0,
        Neutral: 0,
        Satisfied: 0,
        'Very Dissatisfied': 0,
        'Very Satisfied': 0,
      },
    },
  ]
  const legendCategories = {
    Dissatisfied: 0,
    Neutral: 0,
    Satisfied: 0,
    'Very Dissatisfied': 0,
    'Very Satisfied': 0,
  }
  const mapCategoryValues = (value) => {
    switch (value) {
      case 'Very Satisfied':
      case 'Strongly Agree':
        return 'Positive'
      case 'Satisfied':
      case 'Agree':
        return 'Somewhat Positive'
      case 'Neutral':
        return 'Neutral'
      case 'Dissatisfied':
      case 'Disagree':
        return 'Somewhat Negative'
      case 'Very Dissatisfied':
      case 'Strongly Disagree':
        return 'Negative'
      default:
        return value
    }
  }
  const MPF_LABEL = 'MPF Made It Easy For Me'

  const [surveyFormItems, setSurveyFormItems] = useState<any>()
  const [intialsurveyRequestItems, setintialSurveyRequestItems] = useState<any>()
  const [surveyRequestItems, setSurveyRequestItems] = useState<any>()

  const [filteredSurveyList, setFilteredSurveyList] = useState<any>()
  const [surveyCounts, setSurveyCounts] = useState({
    NotSubmittedSurveys: 0,
    SubmittedSurveys: 0,
    TotalSurveys: 0,
  })
const intialFilters =  {
    AssignedComponent: '',
    MAJCOM: '',
    Section: '',
    ServicingOrganization: '',
    year: '',
  }
  const [filters, setFilters] = useState(intialFilters)
  const [filtersOptions, setFiltersOptions] = useState({
    AssignedComponent: [NONE_SELECT_OPTION_STRING],
    MAJCOM: [NONE_SELECT_OPTION_STRING],
    Section: [NONE_SELECT_OPTION_STRING],
    ServicingOrganization: [NONE_SELECT_OPTION_STRING],
    year: [NONE_SELECT_OPTION_STRING],
  })

  useEffect(() => {
    if (isOwners && !isLoading) {
      setShowPageOverlay(true)
      getSurveyReports(SURVEY_FORM_LIST, usersRoles)
        .then((i) => {
          setSurveyFormItems(i.data)
        })
        .catch((error) => {
          ShowErrorMessage(ReturnErrorMessage(error.name))
        })
      getSurveyReports(SURVEY_REQUIRED_LIST, usersRoles)
        .then((i) => {
          setSurveyRequestItems(i.data)
          setintialSurveyRequestItems(i.data)
          setShowPageOverlay(false)
        })
        .catch((error) => {
          ShowErrorMessage(ReturnErrorMessage(error.name))
        })
      clearSearchHandler()
    }
  }, [usersRoles])
  function constructFilterFunction(args) {
    const componentFilters: string[] = []
    const roleFilters: string[] = []
    if (
      Array.isArray(args.assignedComponentCodeFilter) &&
      args.assignedComponentCodeFilter.length > 0
    ) {
      const assignCompFilter = args.assignedComponentCodeFilter.map(
        (AssignedComponent) => `AssignedComponent eq '${AssignedComponent}'`
      )
      componentFilters.push(or(...assignCompFilter))
      roleFilters.push(or(...assignCompFilter))
    }
    if (
      componentFilters.length === 0 &&
      Array.isArray(args.majcomCodeFilter) &&
      args.majcomCodeFilter.length > 0
    ) {
      const assignCompFilter = args.majcomCodeFilter.map((majcom) => `MAJCOM eq '${majcom}'`)
      roleFilters.push(or(...assignCompFilter))
    }
    if (
      componentFilters.length === 0 &&
      Array.isArray(args.servicingOrganizationFilter) &&
      Array.isArray(args.sectionCodeFilter) &&
      args.servicingOrganizationFilter.length > 0 &&
      args.sectionCodeFilter.length > 0
    ) {
      const servicingOrgFilter = args.servicingOrganizationFilter.map((s, i) => {
        const sectionCode = args.sectionCodeFilter?.[i]
        return `(ServicingOrganization eq '${s}' and Section eq '${sectionCode}')`
      })

      roleFilters.push(or(...servicingOrgFilter))
    }
    if (
      componentFilters.length === 0 &&
      Array.isArray(args.servicingOrganizationWithoutSectionFilter) &&
      args.servicingOrganizationWithoutSectionFilter.length > 0
    ) {
      const servicingOrgFilter = args.servicingOrganizationWithoutSectionFilter.map((s) => {
        return `(ServicingOrganization eq '${s}')`
      })

      roleFilters.push(or(...servicingOrgFilter))
    }

    if (Array.isArray(args.CSSPASCODEFilter) && args.CSSPASCODEFilter.length > 0) {
      const cssPascodeFilter = args.CSSPASCODEFilter.map((pascode) => `PASCODE eq '${pascode}'`)
      roleFilters.push(or(...cssPascodeFilter))
    }
    return or(...roleFilters)
  }
  const getSurveyReports = async (List, roleFilters) => {
    const filter = constructFilterFunction(roleFilters)
    const getData = await mpfRListsHttp().getList(List)
    const data = await getData
      .query()
      .filter(filter)
      .orderBy([{ ascending: false, orderBy: 'ItemModified' }])
      .get()
    return { data }
  }

  function genarateOptions(item: string): {
    label: string
    value: string
  }[] {
    const uniqueitems = [...new Set(item)]
    const options = uniqueitems.map((item) => ({ label: item, value: item }))

    if (uniqueitems.length > 1) options.unshift(ALL_SELECT_OPTION_STRING)
    return options
  }
  const generateMappedOptions = (items, key) => genarateOptions(items.map((item) => item[key]))

  const formatName = (name) => {
    return name
      .replace(/([A-Z])/g, ' $1')
      .trim()
      .replace(/M P F/g, 'MPF')
  }

  const chartDataFormatted = chartLayout.map((category) => {
    const counts = {}
    Object.keys(category.value || {}).forEach((key) => {
      counts[key] = 0
    })

    filteredSurveyList?.forEach((item) => {
      const value = item[category.name]
      if (value && counts[value] !== undefined) {
        counts[value]++
      }
    })

    const formattedCounts = {}
    Object.keys(counts).forEach((key) => {
      formattedCounts[mapCategoryValues(key)] = counts[key]
    })

    return {
      name: formatName(category.name),
      ...formattedCounts,
    }
  })
  const categories = new Set()
  chartDataFormatted.forEach((category) => {
    Object.keys(category).forEach((key) => {
      if (key !== 'name') {
        categories.add(key)
      }
    })
  })

  const getYears = (item) => {
    const createdDate = new Date(item.ItemCreated)
    const year = createdDate.getFullYear()
    return year
  }

  const clearSearchHandler = () => {
    if (surveyRequestItems) {
      setFilters(intialFilters)
      calculateSurveyCounts(surveyRequestItems)
    }
  }

  const legendItems = Object.keys(legendCategories).map((key, index) => (
    <div key={key} style={{ alignItems: 'center', display: 'flex' }}>
      <div
        style={{
          backgroundColor: CATEGORY_COLORS_ENUM[key],
          height: '15px',
          marginRight: '5px',
          width: '15px',
        }}
      />
      {key}
    </div>
  ))

  const formatLabelForTooltip = (label, categoryName) => {
    switch (label) {
      case 'Positive':
        return categoryName === MPF_LABEL ? 'Strongly Agree' : 'Very Satisfied'
      case 'Somewhat Positive':
        return categoryName === MPF_LABEL ? 'Agree' : 'Satisfied'
      case 'Neutral':
        return 'Neutral'
      case 'Somewhat Negative':
        return categoryName === MPF_LABEL ? 'Disagree' : 'Dissatisfied'
      case 'Negative':
        return categoryName === MPF_LABEL ? 'Strongly Disagree' : 'Very Dissatisfied'
      default:
        return label
    }
  }

  useEffect(() => {
    if (surveyRequestItems) {
      calculateSurveyCounts(surveyRequestItems)
    }
  }, [surveyRequestItems])
  function calculateSurveyCounts(surveyRequests, order = 1) {
    const submittedSurveys = surveyRequests?.filter((item) => !item.IsFeedbackRequired).length
    const notSubmittedSurveys = surveyRequests?.filter((item) => item?.IsFeedbackRequired).length
    const totalSurveys = submittedSurveys + notSubmittedSurveys
    setSurveyCounts({
      NotSubmittedSurveys: notSubmittedSurveys,
      SubmittedSurveys: submittedSurveys,
      TotalSurveys: totalSurveys,
    })
    const submittedGuids = surveyRequests
      ?.filter((item) => !item.IsFeedbackRequired)
      .map((item) => item.SurveyGUID)

    const generateGraph = surveyFormItems?.filter((item) =>
      submittedGuids.includes(item.SurveyGUID)
    )
    setFilteredSurveyList(generateGraph)
    const yearOptions = genarateOptions(surveyRequestItems.map(getYears))
    const componentOptions =
      order >= filterOrder.AssignedComponent
        ? filtersOptions.AssignedComponent
        : generateMappedOptions(surveyRequests, 'AssignedComponent')
    const majcomOptions =
      order >= filterOrder.ServicingMAJCOM
        ? filtersOptions.MAJCOM
        : generateMappedOptions(surveyRequests, 'MAJCOM')
    const organizationOptions =
      order >= filterOrder.ServicingOrganization
        ? filtersOptions.ServicingOrganization
        : generateMappedOptions(surveyRequests, 'ServicingOrganization')
    const sectionOptions =
      order >= filterOrder.Section
        ? filtersOptions.Section
        : generateMappedOptions(surveyRequests, 'Section')
    setFiltersOptions({
      AssignedComponent: componentOptions,
      MAJCOM: majcomOptions,
      Section: sectionOptions,
      ServicingOrganization: organizationOptions,
      year: yearOptions,
    })
  }
  function filterBy(itemValue, selectedValue) {
    return selectedValue === '' || itemValue === selectedValue
  }
  function onUpdateFilter(value: string, order: number) {
    const cascadingvalue = {
      AssignedComponent:
        order === filterOrder.AssignedComponent
          ? value
          : order > filterOrder.AssignedComponent
          ? filters.AssignedComponent
          : order < filterOrder.AssignedComponent
          ? ''
          : '',
      MAJCOM:
        order === filterOrder.ServicingMAJCOM
          ? value
          : order > filterOrder.ServicingMAJCOM
          ? filters.MAJCOM
          : order < filterOrder.ServicingMAJCOM
          ? ''
          : '',
      Section:
        order === filterOrder.Section
          ? value
          : order > filterOrder.Section
          ? filters.Section
          : order < filterOrder.Section
          ? ''
          : '',
      ServicingOrganization:
        order === filterOrder.ServicingOrganization
          ? value
          : order > filterOrder.ServicingOrganization
          ? filters.ServicingOrganization
          : order < filterOrder.ServicingOrganization
          ? ''
          : '',
      year:
        order === filterOrder.FY
          ? value
          : order > filterOrder.FY
          ? filters.year
          : order < filterOrder.FY
          ? ''
          : '',
    }

    const requestList = intialsurveyRequestItems.filter((item) => {
      return (
        filterBy(getYears(item), cascadingvalue.year) &&
        filterBy(item.AssignedComponent, cascadingvalue.AssignedComponent) &&
        filterBy(item.MAJCOM, cascadingvalue.MAJCOM) &&
        filterBy(item.Section, cascadingvalue.Section) &&
        filterBy(item.ServicingOrganization, cascadingvalue.ServicingOrganization)
      )
    })
    setFilters((prev) => ({
      AssignedComponent: cascadingvalue.AssignedComponent,
      MAJCOM: cascadingvalue.MAJCOM,
      Section: cascadingvalue.Section,
      ServicingOrganization: cascadingvalue.ServicingOrganization,
      year: cascadingvalue.year,
    }))
    calculateSurveyCounts(requestList, order)
  }

  // eslint-disable-next-line react/no-unstable-nested-components
  const CustomTooltip = ({ active, payload }: any) => {
    if (active) {
      return (
        <div
          className='custom-tooltip'
          style={{ backgroundColor: 'white', border: '1px solid black', padding: '10px' }}
        >
          <ul className='list' style={{ listStyleType: 'none', margin: 0, padding: 0 }}>
            {payload.map((data, index) => (
              <li key={index} style={{ color: data.color }}>
                {`${formatLabelForTooltip(data.name, data.payload.name)}: ${data.value}`}
              </li>
            ))}
          </ul>
        </div>
      )
    }
    return null
  }

  return (
    <section className='sectionlistpage Bodysection' id='scroll'>
      { isLoading && showPageOverlay && <PageOverlayBusy />}

      <div className='divcontainer'>
        <div className='row'>
          <div className='col-md-12 col-xs-12'>
            <div className='divlistcommoncontent'>
              <div className='divleftcontainer'>
                <div className='divInnerpagetabs bg-none'>
                  <ul aria-label='Surveys Tabs' role='tablist'>
                    <li>
                      <div
                        // eslint-disable-next-line react/no-unknown-property
                        Survey-kpi-color='1'
                        aria-live='polite'
                        className={`tabs divKpicard`}
                        role='tab'
                        tabIndex={0}
                        title='Total Surveys'
                      >
                        <span className='Spankpicount'>{defaultToEmptyString(surveyCounts.TotalSurveys)}</span>
                        <p>Total Surveys</p>
                      </div>
                    </li>
                    <li>
                      <div
                        // eslint-disable-next-line react/no-unknown-property
                        Survey-kpi-color='2'
                        aria-live='polite'
                        className={`tabs divKpicard`}
                        role='tab'
                        tabIndex={0}
                        title='Submitted'
                      >
                        <span className='Spankpicount'>{defaultToEmptyString(surveyCounts.SubmittedSurveys)}</span>
                        <p>Submitted</p>
                      </div>
                    </li>
                    <li>
                      <div
                        // eslint-disable-next-line react/no-unknown-property
                        Survey-kpi-color='3'
                        aria-live='polite'
                        className={`tabs divKpicard`}
                        role='tab'
                        tabIndex={0}
                        title='Not Submitted'
                      >
                        <span className='Spankpicount'>{defaultToEmptyString(surveyCounts.NotSubmittedSurveys)}</span>
                        <p>Not Submitted</p>
                      </div>
                    </li>
                  </ul>
                </div>

                <div className='divInnerpagetabcontent divSurveybg'>
                  <header>
                    <h1 aria-label=' Survey Form Report' tabIndex={0}>
                      {' '}
                      <span className='icon-graph'></span>Survey Form Report
                    </h1>
                  </header>
                  {surveyCounts.TotalSurveys > 0 ? (
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      <div style={{ flexGrow: 1 }}>
                        <BarChart data={chartDataFormatted} height={300} width={987.2}>
                          <CartesianGrid strokeDasharray='3 3' />
                          <XAxis dataKey='name' />
                          <YAxis />
                          <Tooltip content={<CustomTooltip />} />
                          {Array.from(categories).map((category: any) => (
                            <Bar
                              dataKey={category}
                              fill={CATEGORY_COLORS_ENUM[category]}
                              key={category}
                            />
                          ))}
                        </BarChart>
                      </div>
                      <div
                        className='divsurveygraphlabel'
                        style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}
                      >
                        {legendItems.map((item, index) => (
                          <div key={index} style={{ marginRight: '20px' }}>
                            {defaultToEmptyString(item)}
                          </div>
                        ))}
                      </div>
                    </div>
                  ) : (
                    <div className='min-h-200'>
                      <NO_RESULTS />
                    </div>
                  )}
                </div>
              </div>

              <div className='divrightcontainer'>
                <div className='divfliterbody'>
                  <div className='divdashboardfilters'>
                    <header>
                      <h1>
                        <span aria-label='Dashboard' tabIndex={0}>
                          Filters
                        </span>
                      </h1>
                      <button
                        aria-label='Clear'
                        className='BtnClear'
                        onClick={clearSearchHandler}
                        title='Clear'
                      >
                        {' '}
                        <span className='icon-clear'></span> Clear
                      </button>
                    </header>
                    <div className='row'>
                      <div className='divInquiresfilter'>
                        <div className='col-md-6 col-xl-12'>
                          <div className='divformgroup'>
                            <CustomSelect
                              className='form-sm w-100 sourcesanspro font-13 customselect'
                              formClassName='form-vertical poppins-semibold font-11'
                              id='CalendarYear'
                              label='Calendar Year'
                              name='Calendar Year'
                              onChange={(e) => {
                                onUpdateFilter(e.value, filterOrder.FY)
                              }}
                              options={filtersOptions.year}
                              value={
                                filtersOptions.year.length === 1
                                  ? filtersOptions.year[0].value
                                  : filters.year
                              }
                            />
                          </div>
                        </div>
                        <div className='col-md-6 col-xl-12'>
                          <div className='divformgroup'>
                            <CustomSelect
                              className='form-sm w-100  sourcesanspro font-13 customselect'
                              formClassName='form-vertical poppins-semibold font-11'
                              id='Assigned Component'
                              label='Assigned Component'
                              name='Assigned Component'
                              onChange={(e) => {
                                onUpdateFilter(e.value, filterOrder.AssignedComponent)
                              }}
                              options={filtersOptions.AssignedComponent}
                              value={
                                filtersOptions.AssignedComponent.length === 1
                                  ? filtersOptions.AssignedComponent[0].value
                                  : filters.AssignedComponent
                              }
                            />
                          </div>
                        </div>

                        <div className='col-md-6  col-xl-12'>
                          <div className='divformgroup'>
                            <CustomSelect
                              className='form-sm w-100   sourcesanspro font-13 customselect'
                              formClassName='form-vertical poppins-semibold font-11'
                              id='Servicing MAJCOM'
                              label='Servicing MAJCOM'
                              name='Servicing MAJCOM'
                              onChange={(e) => {
                                onUpdateFilter(e.value, filterOrder.ServicingMAJCOM)
                              }}
                              options={filtersOptions.MAJCOM}
                              value={
                                filtersOptions.MAJCOM.length === 1
                                  ? filtersOptions.MAJCOM[0].value
                                  : filters.MAJCOM
                              }
                            />
                          </div>
                        </div>

                        <div className='col-md-6  col-xl-12'>
                          <div className='divformgroup'>
                            <CustomSelect
                              className='form-sm w-100   sourcesanspro font-13 customselect'
                              formClassName='form-vertical poppins-semibold font-11'
                              id='Servicing organization'
                              label='Servicing organization'
                              name='Servicing organization'
                              onChange={(e) => {
                                onUpdateFilter(e.value, filterOrder.ServicingOrganization)
                              }}
                              options={filtersOptions.ServicingOrganization}
                              value={
                                filtersOptions.ServicingOrganization.length === 1
                                  ? filtersOptions.ServicingOrganization[0].value
                                  : filters.ServicingOrganization
                              }
                            />
                          </div>
                        </div>

                        <div className='col-md-6 col-xl-12'>
                          <div className='divformgroup'>
                            <CustomSelect
                              className='form-sm w-100 sourcesanspro font-13 customselect'
                              formClassName='form-vertical poppins-semibold font-11'
                              id='Section'
                              label='Section'
                              name='Section'
                              onChange={(e) => {
                                onUpdateFilter(e.value, filterOrder.Section)
                              }}
                              options={filtersOptions.Section}
                              value={
                                filtersOptions.Section.length === 1
                                  ? filtersOptions.Section[0].value
                                  : filters.Section
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default SurveyReport
